import { Heading, HStack, SimpleGrid, VStack } from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';

type DocumentsProps = {
  children?: React.ReactNode;
};

export const Documents: React.FC<DocumentsProps> = () => {
  const { property } = usePropertiesModel();
  if (!property?.documents) return null;

  const title = 'Documents';

  const _id = title.toLowerCase().replace(' ', '-');
  return (
    <VStack alignItems={['center', 'flex-start']}>
      <Heading
        id={_id}
        letterSpacing={-0.8}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontWeight="normal"
        fontSize={['28px', '36px']}>
        {title}
      </Heading>
      <SimpleGrid columns={2} w="full">
        {property.documents
          .filter((d) => d.show_on_listing)
          .map((item) => (
            <HStack
              alignItems={'flex-start'}
              justifyItems={'flex-start'}
              _hover={{ color: 'blue.500', cursor: 'pointer' }}
              borderBottomColor={'gray.200'}
              borderBottomWidth={1}
              color="gray.500"
              justifyContent={'space-between'}
              key={`${item.title}`}
              lineHeight={1}
              padding="20px"
              gap="10px"
              onClick={() => {
                if (item.url) {
                  window.open(item.url, '_blank');
                }
              }}
              w="full">
              <TextBlock fontSize={[14, 14, 20]}>{item.title}</TextBlock>
              <Icon icon="arrow-up-right-from-square" boxSize={['14px', '14px', '24px']} variant="regular" />
            </HStack>
          ))}
      </SimpleGrid>
    </VStack>
  );
};
